module.exports = __webpack_public_path__ + "media/images/image-regular-a173153a7321ab96a03fa62c6b0128cd.svg";